module.exports = __webpack_public_path__ + "static/img/banner.ed07181.png";


//////////////////
// WEBPACK FOOTER
// ./static/hire/banner.png
// module id = nohR
// module chunks = 1